module.exports = __webpack_public_path__ + "img/BS.f74bac51.svg";